import {API_BASE_URL, FACEBOOK} from '../../commons/uri';

export const buttons = [
  {name: 'DOŁĄCZ DO NAS NA FACEBOOKU', url: FACEBOOK, color: 'primary', variant: 'contained'},
  {name: 'WRÓĆ NA STRONĘ GŁÓWNĄ', url: API_BASE_URL, color: 'primary', variant: 'outlined'}
];
